//@flow

import React from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../../../../../assets/styles/colors';

type Props = {
  message: string,
};

const useStyles = makeStyles(() => ({
  systemMessage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  message: {
    padding: '0.25rem .75rem',
    borderRadius: '0.5rem',
    backgroundColor: colors.grey400,
    color: colors.grey900,
    fontSize: '0.75rem',
    fontWeight: 500,
    textAlign: 'center',
  },
}));

export default function SystemMessage({message}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.systemMessage}>
      <span className={classes.message}>{message}</span>
    </div>
  );
}
